import * as React from 'react';
import { SharePool, SlimUser, Operations } from 'Core/Api/Api';
import { Row, Col, Table, Button, Popconfirm } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import DetailsMode from 'Core/models/DetailsMode';
import GiftRecipientFormModel from '../GiftRecipientFormModel';
import ShowIfHavePermission from 'components/Forms/ShowIfHavePermission';

export interface Props {
  children?: React.ReactNode;
    value?: GiftRecipientFormModel[];
    onEdit?: (sharePool: GiftRecipientFormModel) => void;
    onDelete?: (sharePool: GiftRecipientFormModel) => void;
}

export interface State {}

export default class GiftRecipientTable extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

      this.state = {};

  }

    onEdit = (sharePool: GiftRecipientFormModel) => {
    if (this.props.onEdit) {
      this.props.onEdit(sharePool);
    }
  };

    onDelete = (sharePool: GiftRecipientFormModel) => {
    if (this.props.onDelete) {
      this.props.onDelete(sharePool);
    }
  };

    tableColumns: Array<ColumnProps<GiftRecipientFormModel>> = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
    },
    {
      title: 'JCSD Number',
        dataIndex: 'jcsdNumber',
      sorter: true,
    },
    {
      title: 'Num of Shares',
        dataIndex: 'numberOfShares',
    },
    {
      title: '',
        render: (text: any, record: GiftRecipientFormModel, index: number) => {
        console.log(record);
        return (
          <>
            <Button onClick={() => this.onEdit(record)}>Edit</Button>

            <Button onClick={() => this.onDelete(record)}>Delete</Button>
          </>
        );
      },
    },
  ];

  render() {
    return (
      <Row>
            <Col span={24}>
          <Table<GiftRecipientFormModel>
            columns={this.tableColumns}
            pagination={this.props.value && this.props.value?.length < 4 ? false : {}}
            dataSource={this.props.value}
          />
        </Col>
      </Row>
    );
  }
}
